import { render, staticRenderFns } from "./CreateLeadArticlesDialog.vue?vue&type=template&id=74479628&"
import script from "./CreateLeadArticlesDialog.vue?vue&type=script&lang=js&"
export * from "./CreateLeadArticlesDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateLeadArticlesDialog.vue?vue&type=style&index=0&id=74479628&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports